import {Component} from '@angular/core';
import {MatCardContent, MatCardModule} from "@angular/material/card";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {CustomIconService} from "projects/admin-portal/src/app/config/custom-icon.service";
import {MatIcon} from "@angular/material/icon";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-processing-dialog',
  standalone: true,
  imports: [
    MatCardModule,
    MatCardContent,
    MatProgressBarModule,
    MatIcon,
    NgOptimizedImage
  ],
  template: `
    <mat-card>
      <img mat-card-image src="../../assets/illustrations/undraw_season_change_f99v.svg">
      <mat-card-header class="pb-10-i">
        <mat-card-title>Still working on it...</mat-card-title>
      </mat-card-header>
      <mat-card-content class="fx-row fx-h-center pt-5-i pb-5-i">
        Please wait while the request is processed.
      </mat-card-content>
      <mat-card-footer>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </mat-card-footer>
    </mat-card>
  `,
})
export class ProcessingDialogComponent {
  constructor(private iconService: CustomIconService,) {
    this.iconService.loadSvgIcons(['illustration-waiting-seasons']);
  }
}
